import { FC, useState, useEffect } from "react";

// Components
import LoanCalculatorInputBox from "./LoanCalculatorInputBox";
import LoanCalculatorOutputBox from "./LoanCalculatorOutputBox";

// Interfaces
import { DRCalculatorInput, DRCalculatorOutput } from "types/DRInterface";

const LoanCalculator: FC<{ getCalendarValues: any }> = (props) => {
  const [calculatorInputValues, setCalculatorInputValues] =
    useState<DRCalculatorInput>({
      loanAmount: 0,
      loanDuration: 0,
    });

  const [calculatorOutputValues, setCalculatorOutputValues] =
    useState<DRCalculatorOutput>({
      loanAmount: 0,
      interestRate: 0,
      monthlyPayment: 0,
      totalPayment: 0,
      APR: 0,
    });

  useEffect(() => {
    props.getCalendarValues({
      loanAmount: calculatorInputValues.loanAmount,
      monthlyPayment: calculatorOutputValues.monthlyPayment,
      interestRate: calculatorOutputValues.interestRate,
      loanDuration: calculatorInputValues.loanDuration,
    });
  }, [calculatorOutputValues]);

  const getCalculatorInputValues = (
    loanAmount: number,
    loanDuration: number
  ) => {
    setCalculatorInputValues({
      loanAmount: +loanAmount,
      loanDuration: +loanDuration,
    });
  };

  const getCalculatorOutputValues = (outputValues: DRCalculatorOutput) => {
    setCalculatorOutputValues(outputValues);
  };

  return (
    <div className="loan-calculator">
      <div className="container loan-calculator__container">
        <LoanCalculatorInputBox
          getCalculatorInputValues={getCalculatorInputValues}
        />
        <LoanCalculatorOutputBox
          loanAmount={calculatorInputValues.loanAmount}
          loanDuration={calculatorInputValues.loanDuration}
          getCalculatorOutputValues={getCalculatorOutputValues}
        />
      </div>
    </div>
  );
};

export default LoanCalculator;
